import { AutoPlay, ContextMenu, Letterbox, LogLevel, OpenURLMode, NetworkingAccessMode, PlayerRuntime, UnmuteOverlay, WindowMode, ScrollingBehavior, DeviceFontRenderer, LoadBehavior, } from "./load-options";
export const DEFAULT_CONFIG = {
    allowScriptAccess: true, // 指示是否允许电影通过 JavaScript 与页面交互
    parameters: {},
    autoplay: AutoPlay.On, // 【自动播放】
    backgroundColor: null,
    letterbox: Letterbox.Fullscreen,
    unmuteOverlay: UnmuteOverlay.Hidden, // 【不显示静音按钮】
    upgradeToHttps: true,
    compatibilityRules: true,
    favorFlash: true,
    warnOnUnsupportedContent: false, // 【不加载不支持的警告层】
    logLevel: LogLevel.Warn, // 日志等级：【Warn】
    showSwfDownload: false,
    contextMenu: ContextMenu.Off, // 【禁用右键菜单】
    // Backwards-compatibility option
    preloader: true,
    splashScreen: true, // 指示是否显示内置的 Ruffle 启动屏幕
    maxExecutionDuration: 3000,
    base: null,
    menu: false, // 【不显示内置的播放，暂停，前进后退等】
    allowFullscreen: false,
    salign: "", // 控制缩放后影片的位置以填充视口并根据需要进行裁剪
    fullScreenAspectRatio: "",
    forceAlign: false,
    quality: null,
    scale: "showAll",
    forceScale: false,
    frameRate: null,
    wmode: WindowMode.Window,
    publicPath: null,
    polyfills: true,
    playerVersion: null,
    preferredRenderer: null,
    openUrlMode: OpenURLMode.Allow,
    allowNetworking: NetworkingAccessMode.All,
    openInNewTab: null,
    socketProxy: [],
    fontSources: [],
    defaultFonts: {},
    credentialAllowList: [],
    playerRuntime: PlayerRuntime.FlashPlayer,
    gamepadButtonMapping: {},
    urlRewriteRules: [],
    scrollingBehavior: ScrollingBehavior.Smart,
    deviceFontRenderer: DeviceFontRenderer.Embedded,
    loadBehavior: LoadBehavior.Streaming, // 影片流加载方式
};
